import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedHeading } from "./Reveal";
import ParallaxImage from "./ParallaxImage";
import { reservarElla } from "../lib/booking";

const servicios = [
  "Uñas & manicure",
  "Spa de pies",
  "Podología",
  "Pestañas",
  "Diseño de cejas",
  "Limpiezas faciales",
  "Depilaciones",
  "Masajes relajantes",
];

const rituales = [
  {
    nombre: "Ritual Blush",
    duracion: "120 min",
    img: "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?auto=format&fit=crop&w=800&q=75&crop=entropy&cs=srgb&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcGElMjBtYXNzYWdlJTIwd29tYW58ZW58MHx8fHwxNzg2Mzk0OTMzfDA&ixlib=rb-4.1.0",
    desc: "Masaje de cuerpo completo con aceites tibios, seguido de limpieza facial hidratante. Un viaje sensorial para soltar tensiones y recuperar el brillo.",
  },
  {
    nombre: "Manos & Pies de Seda",
    duracion: "90 min",
    img: "https://images.unsplash.com/photo-1610992015762-45dca7fa3a85?auto=format&fit=crop&w=800&q=75&crop=entropy&cs=srgb&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcGElMjBtYW5pY3VyZSUyMG5haWxzJTIwdHJlYXRtZW50fGVufDB8fHx8MTc4NjM5NDk4N3ww&ixlib=rb-4.1.0",
    desc: "Manicure y spa de pies de lujo con exfoliación, masaje e hidratación profunda. Tus manos y pies, cuidados al último detalle.",
  },
  {
    nombre: "Mirada Perfecta",
    duracion: "75 min",
    img: "https://images.unsplash.com/photo-1782159981479-5e90597f284a?auto=format&fit=crop&w=800&q=75&crop=entropy&cs=srgb&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxmYWNpYWwlMjB0cmVhdG1lbnQlMjBzcGElMjB3b21hbiUyMHNraW5jYXJlfGVufDB8fHx8MTc4NjM5NDk5N3ww&ixlib=rb-4.1.0",
    desc: "Diseño de cejas, lifting de pestañas y limpieza facial express. Realza tu mirada con un acabado natural y luminoso.",
  },
];

const ExperienceElla = () => {
  return (
    <section
      id="experiencia-ella"
      data-testid="section-ella"
      className="relative bg-[#faf9f6] px-6 pt-20 pb-12 md:px-16 md:pt-28 md:pb-16"
    >
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div>
              <MaskedHeading
                className="font-serif-display text-[#593d36] text-4xl sm:text-5xl lg:text-6xl leading-none"
                lines={["Experiencia"]}
              />
              <MaskedHeading
                className="font-serif-display italic text-[#593d36] text-4xl sm:text-5xl lg:text-6xl leading-tight"
                lines={["Para Ella"]}
                delay={0.15}
              />
            </div>
            <Reveal delay={0.24} className="mt-3">
              <p className="font-cormorant text-xl md:text-2xl italic text-[#cea498] font-semibold">
                Belleza que se siente
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.3} className="max-w-sm">
            <p className="text-sm md:text-base leading-relaxed text-[#6b615c]">
              Un universo luminoso pensado para ti: manicure, spa de pies,
              pestañas, cejas, faciales y masajes en un ambiente cálido de tonos
              salvia y dorados suaves.
            </p>
          </Reveal>
        </div>

        {/* Servicios */}
        <div className="mt-6 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-[#3a3939]/10 md:grid-cols-4">
          {servicios.map((s, i) => (
            <Reveal
              key={s}
              delay={(i % 4) * 0.06}
              className="bg-[#faf9f6] px-5 py-7 transition-colors hover:bg-[#f0e4e1] cursor-default"
            >
              <span className="font-cormorant text-lg text-[#593d36] font-bold md:text-xl">
                {s}
              </span>
            </Reveal>
          ))}
        </div>

        {/* Rituales */}
        <div className="mt-8 grid gap-10 md:grid-cols-3">
          {rituales.map((r, i) => (
            <Reveal key={r.nombre} delay={i * 0.12} className="group">
              <ParallaxImage
                src={r.img}
                alt={r.nombre}
                className="h-72 rounded-2xl"
                overlay="bg-gradient-to-t from-[#3a3939]/25 to-transparent"
              />
              <div className="mt-6 flex items-baseline justify-between">
                <h3 className="font-serif-display text-2xl text-[#593d36] font-bold">
                  {r.nombre}
                </h3>
                <span className="label text-[#cea498] font-bold">{r.duracion}</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-[#6b615c]">
                {r.desc}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-6">
          <motion.button
            data-testid="reservar-ella-btn"
            onClick={reservarElla}
            className="group inline-flex items-center gap-3 rounded-full bg-[#cea498] px-9 py-4 text-[#593d36] font-bold border border-[#593d36]/15"
            whileHover={{ backgroundColor: "#593d36", color: "#faf9f6" }}
          >
            <span className="label">Reservar para Ella</span>
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </motion.button>
        </Reveal>
      </div>
    </section>
  );
};

export default ExperienceElla;
